import React, { useState } from 'react';
import { isChargebackExists } from '../../../../config/LiveApi';
import { useSelector } from 'react-redux';

const ChargebackAlreadyExist = ({ token }) => {
    const [orderId, setOrderId] = useState('');
    const [data, setData] = useState(null);
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const [noChargeback, setNoChargeback] = useState(false);

    const tableHeaders = [
        'Order Id', 'Amount', 'Created At', 'Updated At'
    ];

    const handleSearch = async () => {
        setLoading(true);
        setError('');
        setNoChargeback(false);
        setData(null);
        try {
            const res = await isChargebackExists(orderId, token);
            if (!res || res.length === 0) {
                setNoChargeback(true);
            } else {
                setData(res);
            }
        } catch (err) {
            setError('Failed to fetch chargeback details. Please try again.');
        } finally {
            setLoading(false);
        }
    };


    return (
        <div className="cbe-search-bar" style={{ display: 'flex', flexDirection: 'column' }}>
            <div>
                <input
                    type="text"
                    placeholder="Enter Order Id"
                    value={orderId}
                    onChange={(e) => setOrderId(e.target.value)}
                />
                <button onClick={handleSearch} disabled={loading}>
                    {loading ? 'Searching...' : 'Search'}
                </button>
            </div>
            <div>

                {error && <div className="cb-error-message">{error}</div>}
                {noChargeback && <div className="cb-info-message">No chargeback raised for this Order ID.</div>}

                {!loading && data && (
                    <div className="cbe-table-container">
                        <table className="cbe-table">
                            <thead>
                                <tr>
                                    {tableHeaders.map((header) => (
                                        <th key={header}>{header}</th>
                                    ))}
                                </tr>
                            </thead>
                            <tbody>
                                {data.map((row) => (
                                    <tr key={row.orderId}>
                                        <td>{row.orderId}</td>
                                        <td>{row.amount}</td>
                                        <td>{new Date(row.createdAt).toLocaleString()}</td>
                                        <td className='cbe-updatedAt'>{new Date(row.updatedAt).toLocaleString()}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div>
                )}
            </div>
        </div>
    );
};

export default ChargebackAlreadyExist;
